import { render } from "./CarousalCompTypeOne.vue?vue&type=template&id=cbd782a2"
import script from "./CarousalCompTypeOne.vue?vue&type=script&lang=js"
export * from "./CarousalCompTypeOne.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__